module.exports = __webpack_public_path__ + "img/avatar.bbd83c93.svg";